import { pick } from 'ramda'

class LgPaletteProvider {
	constructor(
		palette,
		private elementFactory,
		private create,
	) {
		palette.registerProvider(this)
	}

	getPaletteEntries() {
		return (actions: object) => {
			// console.log(Object.keys(actions))

			actions['create.user-task'] = this.createAction(
				'bpmn:UserTask',
				'activity',
				'bpmn-icon-user-task',
				'Create user task',
			)
			actions['create.script-task'] = this.createAction(
				'bpmn:ScriptTask',
				'activity',
				'bpmn-icon-script-task',
				'Create script task',
			)
			actions['create.exclusive-gateway'] = this.createAction(
				'bpmn:ExclusiveGateway',
				'gateway',
				'bpmn-icon-gateway-xor',
				'Create exclusive gateway',
			)
			actions['create.parallel-gateway'] = this.createAction(
				'bpmn:ParallelGateway',
				'gateway',
				'bpmn-icon-gateway-parallel',
				'Create parallel gateway',
			)

			actions = pick(
				[
					'hand-tool',
					'lasso-tool',
					'space-tool',
					'global-connect-tool',

					'tool-separator',

					'create.start-event',
					'create.intermediate-event',
					'create.end-event',
					'create.group',
					'create.user-task',
					'create.script-task',
					'create.exclusive-gateway',
					'create.parallel-gateway',
					// 'create.subprocess-expanded',
					// 'create.participant-expanded',
				],
				actions as any,
			)

			// console.log(Object.keys(actions))

			// delete actions['create.data-object']
			// delete actions['create.data-store']
			// delete actions['create.subprocess-expanded'] // remove?
			// // delete actions['create.participant-expanded']

			// delete actions['create.task']

			return actions
		}
	}

	private createAction(
		type: string,
		group: string,
		className: string,
		title: string,
	) {
		// see function createAction in node_modules/bpmn-js/dist/bpmn-modeler.development.js for inspiration
		const createListener = (event: any) => {
			const shape = this.elementFactory.createShape({ type })
			this.create.start(event, shape)
		}

		return {
			group,
			className,
			title,
			action: {
				dragstart: createListener,
				click: createListener,
			},
		}
	}
}
;(LgPaletteProvider as any).$inject = ['palette', 'elementFactory', 'create']

export const LgPaletteProviderModule = {
	__init__: ['lgPaletteProvider'],
	lgPaletteProvider: ['type', LgPaletteProvider],
}
